import React, { useState, useEffect } from "react";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik } from "formik";
import * as Yup from "yup";

import Input from "./bannerInput";
import Button from "./button";
import { useTranslation } from "i18n";

import { triggerEmailForgotPassword } from "api/Auth";

const ForgotPassword = ({ setForgotPass }) => {
  const { t } = useTranslation();
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const validationSchemaEmail = Yup.object().shape({
    email: Yup.string().email().required().label(t("account.email")),
  });

  const handelSubmitForgotPass = async (values) => {
    setLoading(true);
    setErr("");
    const res = await triggerEmailForgotPassword({ email: values.email });
    if (!res.ok) {
      setErr(res?.data?.message);
    } else {
      setSucceeded(true);
    }
    setLoading(false);
  };

  const [succeed, setSucceeded] = useState(false);

  return (
    <div className="login-modal">
      <div className="login-modal__glow" />
      <p className="login-modal__brand">{t("home.appBrand")}</p>
      <h1 className="login-modal__title">{t("auth.forgotPassword")}</h1>
      <p className="login-modal__subtitle">{t("auth.forgotPasswordSubtitle")}</p>
      {err && (
        <Alert severity="error" sx={{ mb: 2, borderRadius: "14px" }}>
          {err}
        </Alert>
      )}
      <Formik
        initialValues={{
          email: "",
        }}
        validationSchema={validationSchemaEmail}
        onSubmit={handelSubmitForgotPass}
      >
        {({
          handleSubmit,
          errors,
          setFieldTouched,
          touched,

          setFieldValue,
        }) => (
          <>
            {succeed ? (
              <p className="bold">
                {t("auth.forgotPasswordInstructions")}
              </p>
            ) : (
              <>
                <Input
                  onChange={(e) => {
                    const value = e.target.value || "";
                    setFieldValue("email", value.toLowerCase());
                  }}
                  error={touched.email && errors.email}
                  onBlur={() => setFieldTouched("email")}
                  name={"email"}
                  mandatory={true}
                  type="email"
                  label={t("auth.enterEmail")}
                />

                <Button
                  type="submit"
                  onClick={handleSubmit}
                  className="bigBtn w-100 primary-color"
                >
                  {loading ? (
                    <CircularProgress sx={{ color: "#fff" }} size={22} />
                  ) : (
                    t("auth.submitEmail")
                  )}
                </Button>

                <p className="login-modal__footer">
                  <button
                    type="button"
                    className="login-modal__link"
                    onClick={() => setForgotPass(false)}
                  >
                    {t("navigation.logIn")}
                  </button>
                </p>
              </>
            )}
          </>
        )}
      </Formik>
    </div>
  );
};

export default ForgotPassword;
